export const FILE_EXTENSIONS = {
  ZIP: "zip",
  MP3: "mp3",
  WAV: "wav",
  OGG: "ogg",
  CSV: "csv",
  XLS: "xls",
  XLSX: "xlsx",
  ODS: "ods",
  TXT: "txt",
  JS: "js",
  PY: "py",
  XML: "xml",
  HTML: "html",
  CONFIG: "config",
  LOG: "log",
  CSS: "css",
  MD: "md",
  YAML: "yaml",
  YML: "yml",
  SH: "sh",
  JAVA: "java",
  PDF: "pdf",
  MP4: "mp4",
  MOV: "mov",
  WEBM: "webm",
  MKV: "mkv",
  MXF: "mxf",
  AVI: "avi",
  GXF: "gxf",
  WMV: "wmv",
  GIF: "gif"
};

export const FILE_PREVIEW_EXTENSIONS = {
  AUDIO_FORMATS: [
    FILE_EXTENSIONS.MP3,
    FILE_EXTENSIONS.WAV,
    FILE_EXTENSIONS.OGG
  ],
  EXCEL_PREVIEW: [
    FILE_EXTENSIONS.CSV,
    FILE_EXTENSIONS.XLS,
    FILE_EXTENSIONS.XLSX,
    FILE_EXTENSIONS.ODS
  ],
  SUPPORTED_TEXT_PREVIEW: [
    FILE_EXTENSIONS.TXT,
    FILE_EXTENSIONS.JS,
    FILE_EXTENSIONS.PY,
    FILE_EXTENSIONS.XML,
    FILE_EXTENSIONS.HTML,
    FILE_EXTENSIONS.CONFIG,
    FILE_EXTENSIONS.LOG,
    FILE_EXTENSIONS.CSS,
    FILE_EXTENSIONS.MD,
    FILE_EXTENSIONS.YAML,
    FILE_EXTENSIONS.YML,
    FILE_EXTENSIONS.SH,
    FILE_EXTENSIONS.JAVA
  ],
  PDF_PREVIEW: [FILE_EXTENSIONS.PDF],
  VIDEO_FORMATS: [
    FILE_EXTENSIONS.MP4,
    FILE_EXTENSIONS.MOV,
    FILE_EXTENSIONS.WEBM,
    FILE_EXTENSIONS.MKV,
    FILE_EXTENSIONS.MXF,
    FILE_EXTENSIONS.AVI,
    FILE_EXTENSIONS.GXF,
    FILE_EXTENSIONS.WMV
  ]
};

export const FILEPREVIEW_PLUGINS = {
  DOWNLOAD: "download",
  NEWTAB: "newtab",
  PIP: "pip",
  FULLSCREEN: "fullscreen",
  SPLITVIEW: "splitview",
  ANNOTATE: "annotate",
  PRINT: "print"
};
